/**
 * 会员等级 → SVG 图标映射（18 级完整）
 * Level 1-18: 实际 SVG | Fallback: level_18
 */

const iconMap = {
  1:  require('@/assets/icons/member-level/level_01_normal.svg'),
  2:  require('@/assets/icons/member-level/level_02_normal.svg'),
  3:  require('@/assets/icons/member-level/level_03_silver.svg'),
  4:  require('@/assets/icons/member-level/level_04_silver.svg'),
  5:  require('@/assets/icons/member-level/level_05_gold.svg'),
  6:  require('@/assets/icons/member-level/level_06_gold.svg'),
  7:  require('@/assets/icons/member-level/level_07_platinum.svg'),
  8:  require('@/assets/icons/member-level/level_08_platinum.svg'),
  9:  require('@/assets/icons/member-level/level_09_diamond.svg'),
  10: require('@/assets/icons/member-level/level_10_diamond.svg'),
  11: require('@/assets/icons/member-level/level_11_blackgold.svg'),
  12: require('@/assets/icons/member-level/level_12_blackgold.svg'),
  13: require('@/assets/icons/member-level/level_13_stellar.svg'),
  14: require('@/assets/icons/member-level/level_14_stellar.svg'),
  15: require('@/assets/icons/member-level/level_15_premium.svg'),
  16: require('@/assets/icons/member-level/level_16_premium.svg'),
  17: require('@/assets/icons/member-level/level_17_elite.svg'),
  18: require('@/assets/icons/member-level/level_18_elite.svg')
}

const FALLBACK = iconMap[18]

export function getLevelIcon (level) {
  return iconMap[level] || FALLBACK
}

export default iconMap
